(function(){
  'use strict';
  function initTerms(root){
    if(!root || root.dataset.rmxTermsReady==='true') return;
    var box=root.querySelector('[data-rmx-terms-checkbox]');
    var summary=root.closest('.rmx-v10-cart-summary');
    var form=root.closest('form');
    var button=(summary&&summary.querySelector('[data-rmx-terms-checkout]'))||(form&&form.querySelector('[data-rmx-terms-checkout]'));
    if(!box || !button) return;
    root.dataset.rmxTermsReady='true';
    var message=root.querySelector('[data-rmx-terms-message]');
    function sync(){
      var accepted=box.checked;
      button.disabled=!accepted;
      button.setAttribute('aria-disabled',accepted?'false':'true');
      if(message&&accepted) message.hidden=true;
    }
    box.addEventListener('change',sync);
    sync();
    if(form){form.addEventListener('submit',function(e){if(!box.checked){e.preventDefault();box.focus();if(message){message.hidden=false;}else{alert('Please agree to the terms before continuing to checkout.');}}});}
  }
  function initAll(scope){(scope||document).querySelectorAll('[data-rmx-cart-terms]').forEach(initTerms);}
  document.addEventListener('DOMContentLoaded',function(){initAll(document);});
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
  document.addEventListener('on:line-item:change',function(){initAll(document);});
})();
